module.exports = __webpack_public_path__ + "static/assets/6be9289547cf046a049e7da8d6958fc7.png";